module.exports = __webpack_public_path__ + "static/media/daydream.d61ee7ab.svg";